export const APPCONSTANTS = {
  CUSTODIAN: 'custodian',
  NONCUSTODIAN: 'noncustodian',
  AVAILABILITYTIMINGS:
    'Please select valid availability one timings between 8AM - 4PM*',
  TIMINGSNOTMORE: 'Please select time slots not more than 1 hour*',
  PHONE: 'Phone',
  EMAIL: 'Email',
  OTHER: 'Other',
  TANF: 'TANF',
  CLOSED: 'Closed',
  MEDICAID: 'Medicaid',
  ARREARSASSIGNED: 'ArrearsAssigned',
  PAYMENTPROCESSING: 'PaymentProcessing',
  ANDROID: 'android',
  IOS: 'ios',
  WEB: 'web',
  OFFLINE: 'Offline',
  ONLINE: 'Online',
  YES: 'Yes',
  NO: 'No',
  OK: 'OK',
  DEL: 'DEL',
  LIMBO: 'Limbo',
  R1: 'R1',
  R2: 'R2',
  GRANTED: 'granted',
  LIMITED: 'limited',
  PROMPT: 'prompt',
  FAILED: 'Failed',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
  CANCELLED: 'CANCELLED',
  CF: 'CF',
  PAYMENT: 'payment',
  ENGLISHLANG: 'en',
  SPANISHLANG: 'es',
  NOMED: 'nomed',
  NOSSN: 'nossn',
  DENIED: 'DENIED',
  SUBMITTED: 'SUBMITTED',
  RECEIVED: 'RECEIVED',
  UNAVAILABLE: 'UN_AVAILABLE',
  INPROGRESS: 'IN_PROGRESS',
  PROCESSED: 'PROCESSED',
  HELPMEURL: 'helpMeURL',
  FATHERHOODURL: 'fatherhoodURL',
  COURTURL: 'courtURL',
  VISITATIONURL: 'visitationURL',
  SMIMAKEPAYMENTURL: 'smiMakepaymentURL',
  PENDINGSUBMISSION: 'PENDING_SUBMISSION',
  USERAGREEMENT: 'user-agreement',
  TECHNICALSUPPORT: 'technical-support',
  CUSTOMERSERVICE: 'customer-service',
  CASEACTIVITY: 'case-activity',
  SHOWCURRENTPASSWORD: 'showCurrentPassword',
  SHOWNEWPASSWORD: 'showNewPassword',
  CASEINITIATION: 'Case Initiation',
  LOCATE: 'Locate',
  VALID: 'VALID',
  ESTABLISHMENT: 'Establishment',
  ENFORCEMENT: 'Enforcement',
  FINANCIAL: 'Financial',
  VIEWPROFILE: 'view-profile',
  EMAILSUBSCRIPTIONS: 'email-subscription',
  DRIVERSLICENSE: 'drivers-license',
  MONTHSARRAY: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
};
